import { render, staticRenderFns } from "./importsdworker.vue?vue&type=template&id=136d1a0c&"
import script from "./importsdworker.vue?vue&type=script&lang=js&"
export * from "./importsdworker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports